import { Box, Grid, TextField, Typography, Chip } from '@mui/material'
import { EventCategory, EVENTS_BY_CATEGORY, CATEGORY_LABELS } from '@tnf-recruit/shared'
import type { RecruiterProfileFormApi } from '../../../hooks/useRecruiterProfileForm'

/** Recruiting focus (events + academic minimums), shared by the onboarding wizard and the edit form. */
export const RecruitingFocusFields = ({ form }: { form: RecruiterProfileFormApi }) => {
  const { data, setData } = form
  const ar = data.recruitingFocus.academicRequirements

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Typography variant="h6" gutterBottom>
          Events (Optional)
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Select the events you are recruiting for
        </Typography>
        {Object.entries(EVENTS_BY_CATEGORY).map(([category, events]) => (
          <Box key={category} sx={{ mb: 2 }}>
            <Typography variant="subtitle2" color="text.secondary" gutterBottom>
              {CATEGORY_LABELS[category as EventCategory]}
            </Typography>
            <Box display="flex" gap={1} flexWrap="wrap" mb={1}>
              {events.map(event => (
                <Chip
                  key={event.id}
                  label={event.name}
                  color={data.recruitingFocus.events.includes(event.id) ? 'primary' : 'default'}
                  onClick={() => {
                    const curr = data.recruitingFocus.events
                    const next = curr.includes(event.id)
                      ? curr.filter(id => id !== event.id)
                      : [...curr, event.id]
                    setData({ ...data, recruitingFocus: { ...data.recruitingFocus, events: next } })
                  }}
                />
              ))}
            </Box>
          </Box>
        ))}
      </Grid>
      <Grid item xs={12} md={4}>
        <TextField
          fullWidth
          label="Minimum GPA (Optional)"
          type="number"
          value={ar.minGPA ?? ''}
          onChange={e => {
            const value = e.target.value
            setData({
              ...data,
              recruitingFocus: {
                ...data.recruitingFocus,
                academicRequirements: { ...ar, minGPA: value === '' ? undefined : Number(value) },
              },
            })
          }}
          inputProps={{ min: 0, max: 4, step: 0.1 }}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <TextField
          fullWidth
          label="Minimum SAT (Optional)"
          type="number"
          value={ar.minSAT ?? ''}
          onChange={e => {
            const value = e.target.value
            setData({
              ...data,
              recruitingFocus: {
                ...data.recruitingFocus,
                academicRequirements: { ...ar, minSAT: value === '' ? undefined : Number(value) },
              },
            })
          }}
          inputProps={{ min: 400, max: 1600, step: 10 }}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <TextField
          fullWidth
          label="Minimum ACT (Optional)"
          type="number"
          value={ar.minACT ?? ''}
          onChange={e => {
            const value = e.target.value
            setData({
              ...data,
              recruitingFocus: {
                ...data.recruitingFocus,
                academicRequirements: { ...ar, minACT: value === '' ? undefined : Number(value) },
              },
            })
          }}
          inputProps={{ min: 1, max: 36, step: 1 }}
        />
      </Grid>
    </Grid>
  )
}
